import { Observable, timer, from } from 'rxjs';
import { switchMap, retry, catchError } from 'rxjs/operators';
import { createApiClient } from '../services/api/httpClient';

export const createLongPollingObservable = <T>(
  endpoint: string,
  token?: string,
  intervalMs: number = 5000,
  fallbackData?: T,
): Observable<T> => {
  return timer(0, intervalMs).pipe(
    switchMap(() => {
      const tokenProvider = token ? () => token : undefined;
      const apiClient = createApiClient(tokenProvider);
      return from(apiClient.get<T>(endpoint));
    }),
    retry({ count: 3, delay: 1000 }),
    catchError((error) => {
      console.error(`Long polling error for ${endpoint}:`, error);
      return from(Promise.resolve(fallbackData as T));
    }),
  );
};
